<div class="d-flex flex-column flex-root">
  <!--begin::Login-->
  <div
    class="login login-2 login-signin-on d-flex flex-column flex-lg-row flex-column-fluid bg-white"
    id="kt_login"
  >
    <!--begin::Aside-->
    <div
      class="login-aside order-2 order-lg-1 d-flex flex-row-auto position-relative overflow-hidden"
    >
      <!--begin: Aside Container-->
      <div
        class="d-flex flex-column-fluid flex-column justify-content-between py-9 px-7 py-lg-13 px-lg-35"
      >
        <!--begin::Logo-->
        <a href="#" class="text-center pt-2">
          <img src="assets/media/logos/logo_cangio.png" alt="" />
        </a>
        <!--end::Logo-->

        <!--begin::Aside body-->
        <div class="d-flex flex-column-fluid flex-column flex-center">
          <router-outlet></router-outlet>
        </div>
        <!--end::Aside body-->

        <!--begin: Aside footer for desktop-->
        <div class="text-center">

        </div>
        <!--end: Aside footer for desktop-->
      </div>
      <!--end: Aside Container-->
    </div>
    <!--begin::Aside-->

    <!--begin::Content-->
    <div
      class="content order-1 order-lg-2 d-flex flex-column w-100 pb-0"
      style="background-color: #b1dced"
    >
      <!--begin::Title-->
      <div
        class="d-flex flex-column justify-content-center text-center pt-lg-40 pt-md-5 pt-sm-5 px-lg-0 pt-5 px-7"
      >
        <h3
          class="display4 font-weight-bolder my-7 text-dark"
          style="color: #986923"
        >
          HUYỆN CẦN GIỜ - TP HỒ CHÍ MINH
        </h3>
        <p
          class="font-weight-bolder font-size-h2-md font-size-lg text-dark opacity-70"
        >
          Hệ thông quản lý lịch họp trực tuyến <br>
          Và các thông tin về hoạt động của Huyện Cần Giờ
        </p>
      </div>
      <!--end::Title-->

      <!--begin::Image-->
      <div
        class="content-img d-flex flex-row-fluid bgi-no-repeat bgi-position-y-bottom bgi-position-x-center"
        style="
          background-image: url(assets/media/svg/illustrations/login-visual-2.svg);
        "
      ></div>
      <!--end::Image-->
    </div>
    <!--end::Content-->
  </div>
  <!--end::Login-->
</div>
